"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
var react_1 = __importDefault(require("react"));
var ra_fetch_1 = require("ra-fetch");
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
function indexParams(user) {
    var params = {
        page: 1,
        paginate: 10,
        sort: 'name asc',
        details: true,
    };
    if (user.role === 'coach') {
        params.club_id = user.channel.id;
    }
    return params;
}
var List = function (_a) {
    var user = _a.user;
    var _b = storybook_1.Hooks.useModal(), Modal = _b[0], setModal = _b[1];
    var _c = ra_fetch_1.useApi('backend')
        .index('channels', indexParams(user)), channels = _c[0], setChannel = _c[1], params = _c[2], setParams = _c[3];
    var _d = storybook_1.Hooks.useSearch(params, setParams), search = _d[0], setSearch = _d[1];
    var Request = function (page) {
        setParams(__assign(__assign({}, params), { page: page }), page !== 1);
    };
    return react_1.default.createElement(storybook_1.Layouts.Container, null,
        react_1.default.createElement(Modal, null),
        user.role !== 'coach' &&
            react_1.default.createElement(storybook_1.Lists.Filters, { params: params, setParams: setParams },
                react_1.default.createElement(storybook_1.Forms.Select, { value: params.hidden, onChange: function (hidden) {
                        hidden ? setParams(__assign(__assign({}, params), { page: 1, hidden: hidden })) : setParams(initialParams);
                    } },
                    react_1.default.createElement("option", { value: '' }, "Alle kanalen"),
                    react_1.default.createElement("option", { value: 0 }, "Publieke kanalen"),
                    react_1.default.createElement("option", { value: 1 }, "Verborgen kanalen")),
                react_1.default.createElement(storybook_1.Forms.Input, { placeholder: 'Zoeken...', value: search, onChange: setSearch })),
        channels.meta.total === 0 && !channels.loading &&
            react_1.default.createElement(storybook_1.Forms.New, { description: 'Je hebt nog geen kanalen', label: 'Nieuw Kanaal', to: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/channels/create", icon: 'plus' }),
        channels.data.length !== 0 && react_1.default.createElement(storybook_1.Channels.List, { channels: channels, onDelete: function (channel) { return setModal({
                content: function () { return react_1.default.createElement(storybook_1.Forms.DeleteModal, { title: channel.name, route: 'channels', api: 'backend', params: { id: channel.id, channel_id: user.channel.id } }); },
            }); } }),
        react_1.default.createElement(storybook_1.Lists.Lazyload, { loading: channels.loading, load: channels.meta.current_page !== channels.meta.last_page, onEnter: function () { return Request(channels.meta.current_page + 1); } }));
};
exports.List = List;
exports.List.propTypes = {
    /**
     * Current channel session
     */
    channel: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
    }).isRequired,
    /**
     * The Params for the request
     */
    params: prop_types_1.default.object,
};
exports.List.defaultProps = {};
